<pop-settings-box labelKey="DATA_MANAGEMENT.SELECT_DEPARTMENT">
  <pop-department-picker [(selectedDepartment)]="selectedDepartment"
                         styleClass="rem-fix"></pop-department-picker>
</pop-settings-box>
<div class="spacer"></div>

<pop-settings-box labelKey="DATA_MANAGEMENT.SELECT_PROJECT">
  <div middle
       class="project-switches">
    <div class="project-switch">
      <span class="label"
            translate="DATA_MANAGEMENT.SHOW_ALL_PROJECTS"></span>
      <pop-switch [(isSwitched)]="showAllProjects"
                  (isSwitchedChange)="toggleShowAllProjects()"></pop-switch>
    </div>
  </div>

  <pop-project-picker #projectPicker
                      [importMode]="true"
                      [(selectedProject)]="selectedProject"
                      (selectedProjectChange)="onSelectedProjectChanged()"
                      [projectFilter]="filterProjects"
                      [style]="{ width: '350px' }"
                      styleClass="rem-fix"></pop-project-picker>
</pop-settings-box>

<div class="spacer"></div>

<pop-settings-box labelKey="DATA_MANAGEMENT.REFERENCE_CODE">
  <div middle
       class="ref-code-desc">
    <span translate="DATA_MANAGEMENT.REFERENCE_CODE_DESC"></span>
  </div>

  <span class="p-input-icon-right">
    <i class="pi pi-times"
       *ngIf="referenceCode"
       (click)="referenceCode = ''"></i>
    <input type="text"
           [disabled]="!selectedProject"
           [(ngModel)]="referenceCode"
           [placeholder]="referenceCodeFallback || ''"
           pInputText />
  </span>
</pop-settings-box>

<div class="spacer"></div>

<button class="pop-button"
        [disabled]="!canImportProject"
        translate="DATA_MANAGEMENT.IMPORT_PROJECT"
        (click)="importProject()"></button>
<div class="spacer"></div>

<div *ngFor="let result of resultsList">
  <div class="box box-success">
    <div>
      <a [routerLink]="result?.routerLink">{{ result.referenceCode }}</a>
      <span [translate]="result.titleKey"></span>
    </div>
  </div>

  <div class="spacer"></div>
</div>
